export default "__VITE_ASSET__DGirFEGV__"